module.exports = "<div class=\"img-error-center\">\r\n\t<img src=\"./assets/accessDenied.jpg\">\r\n</div>"